<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">ImageIndex</a>
      <a
        role="button"
        class="navbar-burger burger"
        aria-label="menu"
        aria-expanded="false"
        v-on:click="toggleBurgerMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarMenu" v-bind:class="{'navbar-menu': true, 'is-active': show_burger_menu}">
      <div class="navbar-start" v-if="logged_in">
        <router-link
          class="navbar-item"
          v-for="item in items"
          v-bind:key="item.route"
          v-bind:to="item.route"
          v-bind:class="{ 'is-active': item.title == route.name}"
        >{{ item.title }}</router-link>
        <router-link
          class="navbar-item"
          v-if="user.groups.indexOf('admin') >= 0"
          v-bind:class="{ 'is-active': 'Administration' == route.name}"
          to="/administration">
            Administration
        </router-link>
      </div>
      <div class="navbar-end" v-if="logged_in">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link">
            <i class="im im-user-male" aria-hidden="true"></i>
            {{user.name}}
          </a>

          <div class="navbar-dropdown">
            <router-link
              class="navbar-item"
              to="/profile">
              Profil
            </router-link>
            <a class="navbar-item" v-on:click="logout">Logout</a>
          </div>
        </div>
      </div>
    </div>

  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  computed: mapState(['route', 'user', 'logged_in', 'show_burger_menu']),
  data() {
    return {
      items: [
        { title: "Dashboard", icon: "dashboard", route: "/" },
        { title: "Friends", icon: "friends", route: "/friends" },
        { title: "Search", icon: "search", route: "/search" },
        { title: "Upload", icon: "cloud_upload", route: "/upload" },
      ]
    };
  },
  methods: {
    logout() {
      console.log(this.user.groups.indexOf('admin'))
      this.$store.dispatch("logout");
      window.localStorage.removeItem("loginData");
      this.$router.push("/login");
    },
    ...mapActions(['toggleBurgerMenu'])
  }
};
</script>
